import { render, staticRenderFns } from "./NewTag2.vue?vue&type=template&id=74daccba&scoped=true&"
import script from "./NewTag2.vue?vue&type=script&lang=js&"
export * from "./NewTag2.vue?vue&type=script&lang=js&"
import style0 from "./NewTag2.vue?vue&type=style&index=0&id=74daccba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74daccba",
  null
  
)

export default component.exports